import { render, staticRenderFns } from "./RecepcionRetirosIndependientes.vue?vue&type=template&id=1112aac9"
import script from "./RecepcionRetirosIndependientes.vue?vue&type=script&lang=js"
export * from "./RecepcionRetirosIndependientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports